import React from 'react'
import { Text } from '../../../../elementals'
import Icon from '../../../../elementals/icon'
import PopupTooltip from '../../../../overlays/popupTooltip'
import { AutomationTarget } from '../../../../../types'

interface BidRankColumnHeaderProps extends AutomationTarget {
  label: string
  isMobile?: boolean
  tooltipContent?: string
}

export default ({
  label,
  elmId,
  isMobile,
  tooltipContent,
}: BidRankColumnHeaderProps) => (
  <Text
    weight='heavy'
    color='gray'
    data-elm-id={elmId}
    size={isMobile ? 'tiny' : 'small'}
  >
    {label}
    {tooltipContent && (
      <span className='u-ml-1'>
        <PopupTooltip
          offset={0}
          horizontalOffset={0}
          verticalOffset={0}
          content={tooltipContent}
          wide={false}
          trigger={
            <Icon
              size='small'
              color='gray'
              name='info-circle'
              fitted
              style={{ verticalAlign: 'super' }}
              iconStyle='solid'
            />
          }
        />
      </span>
    )}
  </Text>
)
